import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { Avatar, Heading, Paragraph, Skeleton } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

export default function Preview(props: { group: graphql.Group }) {
	const { t } = useTranslation();

	const query = graphql.useGroupMembersQuery({ variables: { id: props.group.id } });

	const managers = query.data?.group.members.edges.filter(
		(edge) => edge.role.type !== graphql.RoleType.Member,
	);
	const members = query.data?.group.members.edges.filter(
		(edge) => edge.role.type === graphql.RoleType.Member,
	);

	return (
		<Box p={3}>
			<Heading>{props.group.name}</Heading>
			<Box mt={2}>
				<Paragraph>{t('groups.selector.preview.managers.ttile')}</Paragraph>
				{query.data ? (
					managers?.length === 0 ? (
						<Flex>
							<Skeleton.Empty
								contents={
									<Paragraph textAlign="center" style={{ whiteSpace: 'pre' }}>
										{t('groups.selector.preview.managers.empty')}
									</Paragraph>
								}
								mt={1}
							>
								<Flex>
									<Skeleton.Repeat count={5}>
										<Avatar.Skeleton size={32} mr={2} />
									</Skeleton.Repeat>
								</Flex>
							</Skeleton.Empty>
						</Flex>
					) : (
						<Flex mt={1}>
							{managers
								?.slice(0, 4)
								.map(({ node }) => (
									<Avatar key={node.id} user={node as graphql.User} mr={2} size={32} />
								))}
							{managers && managers.length > 4 && (
								<Avatar.Overflow count={managers.length - 4} size={32} />
							)}
						</Flex>
					)
				) : (
					<Flex mt={1}>
						<Avatar.Skeleton mr={2} size={32} />
						<Avatar.Skeleton mr={2} size={32} />
						<Avatar.Skeleton mr={2} size={32} />
						<Avatar.Skeleton mr={2} size={32} />
						<Avatar.Skeleton mr={2} size={32} />
					</Flex>
				)}
			</Box>
			<Box mt={3}>
				<Paragraph>{t('groups.selector.preview.employees.title')}</Paragraph>
				{query.data ? (
					members?.length === 0 ? (
						<Flex>
							<Skeleton.Empty
								contents={
									<Paragraph textAlign="center" style={{ whiteSpace: 'pre' }}>
										{t('groups.selector.preview.employees.empty')}
									</Paragraph>
								}
								mt={1}
							>
								<Flex>
									<Skeleton.Repeat count={5}>
										<Avatar.Skeleton size={32} mr={2} />
									</Skeleton.Repeat>
								</Flex>
							</Skeleton.Empty>
						</Flex>
					) : (
						<Flex mt={1}>
							{members
								?.slice(0, 4)
								.map(({ node }) => (
									<Avatar key={node.id} user={node as graphql.User} mr={2} size={32} />
								))}
							{members && members.length > 4 && (
								<Avatar.Overflow count={members.length - 4} size={32} />
							)}
						</Flex>
					)
				) : (
					<Flex mt={1}>
						<Avatar.Skeleton mr={2} size={32} />
						<Avatar.Skeleton mr={2} size={32} />
						<Avatar.Skeleton mr={2} size={32} />
						<Avatar.Skeleton mr={2} size={32} />
						<Avatar.Skeleton mr={2} size={32} />
					</Flex>
				)}
			</Box>
		</Box>
	);
}
